import { LitElement, css, html } from "lit";
import { customElement, property, query, state } from "lit/decorators.js";

import { newsletterSignUp } from "../../data/user";

@customElement("bp-global-footer-email-form")
export class GlobalFooterEmailForm extends LitElement {
  static styles = css`
    :host {
      display: block;
    }

    form {
      display: grid;
      grid-template-rows: auto;
      gap: var(--size-2);
      color: var(--color-white);
    }

    .form-text {
      font-size: var(--font-size-lg);
      font-weight: var(--font-weight-semibold);
      max-width: 24ch;
    }

    .form-control {
      display: grid;
      grid-template-columns: 1fr auto;
      gap: var(--size-1-5);
      align-items: stretch;
    }

    input {
      background-color: transparent;
      padding: var(--size-2) var(--size-1-5);
      color: currentColor;
      border: 1px solid currentColor;
      border-radius: var(--radius-md);
      font-size: var(--font-size-md);
      font-family: var(--font-sans);
      box-sizing: border-box;
      height: var(--size-7);
    }

    input::placeholder {
      color: var(--color-neutral-20);
    }

    input:disabled {
      background-color: var(--color-neutral-60);
    }

    button {
      appearance: none;
      border: 0;
      display: inline-flex;
      align-items: center;
      line-height: none;
      background-color: var(--color-white);
      padding: var(--size-2);
      border-radius: var(--radius-lg);
      box-sizing: border-box;
      height: var(--size-7);
      aspect-ratio: 1;
      cursor: pointer;
    }

    .success-message {
      box-sizing: border-box;
      height: var(--size-7);
      display: flex;
      align-items: center;
      padding: var(--size-2);
      border-radius: var(--radius-md);
      background-color: var(--color-green-10);
      color: var(--color-green-60);
    }

    @media (min-width: 1024px) {
      .form-text {
        font-size: var(--font-size-4xl);
        max-width: 18ch;
      }
    }
  `;

  @property({ attribute: "handler-id" })
  handlerId?: string;

  @property()
  placeholder?: string;

  @property({ attribute: "label-success" })
  labelSuccess?: string;

  @state()
  busy = false;

  @state()
  submitted = false;

  @query("input")
  input?: HTMLInputElement;

  handleSubmit = (e: SubmitEvent) => {
    e.preventDefault();

    if (!this.input || !this.handlerId) return;

    this.busy = true;

    newsletterSignUp(this.input.value, { handler: this.handlerId }).finally(
      () => {
        this.submitted = true;
        this.busy = false;
      },
    );
  };

  render() {
    return html`
      <form aria-busy="${this.busy}" @submit="${this.handleSubmit}">
        <div class="form-text">
          <slot></slot>
        </div>

        ${this.submitted
          ? html`
              <div class="success-message" aria-live="polite">
                ${this.labelSuccess}
              </div>
            `
          : html`
              <div class="form-control">
                <input
                  type="email"
                  placeholder="${this.placeholder}"
                  required
                  ?disabled=${this.busy}
                />

                <button aria-label="Submit">
                  ${this.busy
                    ? html` <bp-spinner size="md"></bp-spinner> `
                    : html` <bp-icon icon="arrow-right"></bp-icon> `}
                </button>
              </div>
            `}
      </form>
    `;
  }
}
